export enum DeviceStatus {
  registeredStr = 'registered',
  provisioningInitiatedStr = 'provisioning_initiated',
  provisioningErrorStr = 'provisioning_error',
  provisionedStr = 'provisioned',
}
